import * as Yup from "yup";

export const curriculumSchema = Yup.object().shape({
  category1UID: Yup.number(), // 대분류 UID
  category2UID: Yup.number(), // 중분류 UID
  category3UID: Yup.number(), // 세분류 UID
  tutorUID: Yup.number(), // 강사 UID
  year: Yup.number(),
  month: Yup.number(),
  minusPoint: Yup.number().positive("양수만 입력하세요").max(100, "최대값은 100입니다."), // 감점 폭
  base64: Yup.string(),
  departmentsUIDs: Yup.array().of(Yup.number()), // 대상 부서

  // note not used
  // uid: Yup.number(),
  // companyUID: Yup.number(), // 업체 UID

  // textBookFile: Yup.string(), // 교안등록 파일명
  // hasNotExam: Yup.boolean(), // 응시/미응시 여부 - 미응시 - true
  // maxTrialCount: Yup.number(), // 최대 응시 횟수
  // isDeleted: Yup.boolean(), // 삭제 여부
  // timeLimit: Yup.number(), // 시험 시간 제한
  // originDate: Yup.string(), // 시험 기준일

  // excludes: Yup.array(Yup.string()), // 제외 여부

  // // NOT DB
  // departmentsUIDs: Yup.array(Yup.number()), // 대상 부서 UID 목록
  // allTrialCount: Yup.number(), // 평가자
  // allExamerCount: Yup.number(), // 대상자
  // allScoreAverage: Yup.number(), // 평균점수
});
